// extracted by mini-css-extract-plugin
module.exports = {"title":"Section_title__2uRb6"};